// Background particles fragment shader
// Soft feathered circles in warm cream/gold tones.

varying float vAlpha;

void main() {
    vec2  uv   = gl_PointCoord - vec2(0.5);
    float dist = length(uv) * 2.0;

    float alpha = 1.0 - smoothstep(0.4, 1.0, dist);

    // Warm parchment colour
    vec3 col = vec3(0.91, 0.84, 0.69);

    gl_FragColor = vec4(col, alpha * vAlpha);

    #include <colorspace_fragment>
}
